import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiCall } from "../utils/apiService";
import "./AuthPage.css";

const SignUpLayer = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        try {
            const data = await apiCall({
                url: `user/signup`,
                method: "Post",
                body: { email, password, name },
            });
            if (data.success) {
                window.location.href = "/login";
            } else {
                setError(data.msg || data.message || "Could not create account");
            }
        } catch (err) {
            setError(err.message || "Could not create account");
            console.error("Signup error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        document.title = "Sign Up";
    }, []);

    return (
        <div className="auth-page">
            <div className="auth-shell">
                <aside className="auth-aside">
                    <div>
                        <Icon icon="mdi:whatsapp" width={36} />
                        <h2>Create your messaging workspace</h2>
                        <p>
                            Start connecting WhatsApp sessions and sending smarter campaigns in
                            minutes.
                        </p>
                        <ul className="auth-aside-points">
                            <li><span className="dot" /> Free to get started</li>
                            <li><span className="dot" /> API + dashboard included</li>
                            <li><span className="dot" /> Live delivery tracking</li>
                        </ul>
                    </div>
                    <p style={{ opacity: 0.8, fontSize: "0.8rem" }}>© AlphaXCloud</p>
                </aside>

                <div className="auth-panel">
                    <Link to="/" className="d-block text-center">
                        <img
                            className="auth-logo"
                            src="/assets/images/alphaxcloud.svg"
                            alt="AlphaXCloud"
                        />
                    </Link>
                    <h6>Create your account</h6>
                    <p className="auth-sub">Enter your details to get started</p>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <div className="icon-field">
                                <span className="icon">
                                    <Icon icon="f7:person" />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Full name"
                                    value={name}
                                    required
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="mb-3">
                            <div className="icon-field">
                                <span className="icon">
                                    <Icon icon="mage:email" />
                                </span>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Email"
                                    value={email}
                                    required
                                    autoComplete="username"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="password-field mb-3">
                            <div className="icon-field">
                                <span className="icon">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Password"
                                    value={password}
                                    required
                                    autoComplete="new-password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <button
                                type="button"
                                className="toggle-password"
                                aria-label={showPassword ? "Hide password" : "Show password"}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <Icon
                                    icon={showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                                    width={20}
                                    height={20}
                                />
                            </button>
                        </div>

                        {error ? <div className="auth-error">{error}</div> : null}

                        <button type="submit" className="auth-submit" disabled={isLoading}>
                            {isLoading ? "Creating account…" : "Sign up"}
                        </button>

                        <div className="auth-footer">
                            Already have an account? <Link to="/login">Sign in</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignUpLayer;
